import React, { useEffect, useState } from "react";
import { pushToPrivacy } from "core/privacy/utils";
import { View } from "./View";
export var Provider = function (_a) {
    var category = _a.category, className = _a.className, variant = _a.variant, children = _a.children;
    var _b = useState({
        kind: "Loading",
    }), consentGiven = _b[0], setConsentGiven = _b[1];
    var categoryPush = function () {
        return pushToPrivacy(window, [
            category,
            function () {
                setConsentGiven({ kind: "Set", given: true });
            },
            function () {
                setConsentGiven({ kind: "Set", given: false });
            },
        ]);
    };
    var consentUpdatedPush = function () {
        return pushToPrivacy(window, [
            "consentupdated",
            function () {
                categoryPush();
            },
        ]);
    };
    useEffect(function () {
        categoryPush();
    }, []);
    useEffect(function () {
        consentUpdatedPush();
    }, []);
    if (consentGiven.kind === "Loading")
        return null;
    return consentGiven.given ? (React.createElement(React.Fragment, null, children)) : (React.createElement(View, { className: className, variant: variant }));
};
